import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { logoutUser } from "actions";
import PropTypes from "prop-types";
import Button from "components/Common/Button";
import { modalKeepOpen } from "./actions";
import "./style.scss";

const BLOCK_NAME = "ModalEnforceMFA";
export class ModalEnforceMFA extends React.Component {
  /** */
  componentDidMount() {
    const { makeUnclosable } = this.props;
    makeUnclosable();
  }

  /**
   * renders the component
   * @returns {ReactElement} ModalEnforceMFA
   */
  render() {
    const { modalLogoutUser } = this.props;

    return (
      <div className={`${BLOCK_NAME} Modal_modal`}>
        <h5 className="Modal__title">Session Expired</h5>
        <div className="Modal__content">
          <section className="Modal__section ModalEnforceMFA__details">
            <p>Sorry, Your session has expired.</p>
            <p>Please login to continue using Ada.</p>
          </section>
        </div>

        <div className={`${BLOCK_NAME}__bottom`}>
          <Button
            text="Log In"
            stretched
            lightPrimary
            onClick={modalLogoutUser}
            disabledStyleFlat
            customClassName={`${BLOCK_NAME}__button`}
          />
        </div>
      </div>
    );
  }
}

ModalEnforceMFA.isSmall = true;

ModalEnforceMFA.propTypes = {
  modalLogoutUser: PropTypes.func.isRequired,
  makeUnclosable: PropTypes.func.isRequired
};


/**
 * @param {Object} state
 * @returns {Object}
 */
function mapState(state) {
  const {
    user
  } = state;

  return {
    user
  };
}

/**
 * @param {Function} dispatch
 * @returns {Object}
 */
function mapDispatch(dispatch) {
  return {
    modalLogoutUser: bindActionCreators(logoutUser, dispatch),
    makeUnclosable: bindActionCreators(modalKeepOpen, dispatch)
  };
}

const Connector = connect(
  mapState,
  mapDispatch
)(ModalEnforceMFA);

export default Connector;
